import { ENTITLEMENTS } from '../../application-core/constants';
import PersonIcon from '@material-ui/icons/Person';
import AssignUserDialog from './AssignUserDialog';
import ExpandMore from '@material-ui/icons/ArrowDropDown';
import ExpandLess from '@material-ui/icons/ArrowDropUp';
import AssignmentReturnedIcon from '@material-ui/icons/AssignmentReturned';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import IconButton from '@material-ui/core/IconButton';
import DiscussionViewer from '../../core/discussion/DiscussionViewer';
import Tooltip from '@material-ui/core/Tooltip';
import LangConfirmationField from '../LangConfirmationField';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { globalStyles as styles } from '../style/gstheme';
import withGS from '../withGShoc';
import { STATUS_ACCEPTED, STATUS_REJECTED, STATUS_PENDING } from '../utils/constants';

const APPROVED = STATUS_ACCEPTED;
const REJECTED = STATUS_REJECTED;
const PENDING = STATUS_PENDING;

class TaskViewerTaskDisplay extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
      showAssignUserDialog: false
    };
    if (this.props.data.status && this.props.data.status[0] !== PENDING && this.props.onTaskCompletion) {
      this.props.onTaskCompletion(this.props.id);
    }
  }

  setToStatus = (status) => {
    if (this.props.data.status !== undefined) {
      // Something has gone wrong!
      if (this.props.data.status.length > 1) return;
      // Just make sure nobody else had set it
      if (this.props.data.status !== status) {
        this.props.onUpdate('status', status, null, 0);
      }
    }
    else {
      this.props.onAdd('status', status);
    }
    if (this.props.onTaskCompletion) this.props.onTaskCompletion(this.props.id);
  };

  showAssignUser = () => this.setState({ showAssignUserDialog: true });

  cancelAssignUser = () => this.setState({ showAssignUserDialog: false });

  assignUser = (user) => {
    if (user === "All") user = undefined;
    this.setState({ showAssignUserDialog: false, user });
    if (!(this.props.data.assignedUser === undefined && user === undefined)) {
      this.props.data.assignedUser !== undefined ?
        user === undefined ?
          this.props.onDelete('assignedUser', this.props.data.assignedUser)
          :
          this.props.onUpdate('assignedUser', user)
        :
        this.props.onAdd('assignedUser', user);
    }
  };

  expandTask = () => this.setState({ expanded: true });

  collapseTask = () => this.setState({ expanded: false });

  render() {

    const { data, classes, defaultLang, projectUsers, isReadOnly, graph, manager, currentUser, entitlements, disabled } = this.props;
    const { assignedUser, assignedNote, user, created, hasDiscussion, status } = data;
    const { expanded, showAssignUserDialog } = this.state;
    const date = created ? new Date(created) : null;
    const dateText = date ? date.toLocaleString() : "";

    const foundAssignedUser = projectUsers.find(user => user.value === assignedUser);
    const assigned = assignedUser ?
      foundAssignedUser ?
        foundAssignedUser.label
        :
        "User not available"
      :
      "Unassigned";

    const usedStatus = status ?
      Array.isArray(status) ?
        status[0]
        :
        status
      :
      null;

    const userId = Array.isArray(user) ? user[0] : user;
    const foundCreatedUser = projectUsers.find(pu => pu.value === userId);
    const createdBy = foundCreatedUser ?
      foundCreatedUser.label
      :
      !user ?
        "Automated"
        :
        "User not available";

    const isDeleted = data.pendingDeletion;
    const canEditTask = !disabled && (entitlements.includes(ENTITLEMENTS.EDIT_TASK) || entitlements.includes(ENTITLEMENTS.CREATE_TASK));

    return (
      <React.Fragment>
        <TableRow
          style={{
            backgroundColor: isDeleted ?
              '#DD2C00'
              :
              usedStatus !== PENDING ?
                '#f5f5f5'
                :
                '#eeeeee',
            color: usedStatus !== PENDING ?
              '#888'
              :
              'black',
            borderBottom: expanded ? 'none' : 'solid 12px white'
          }}>
          <TableCell component="td" className={classes.tableCell} style={{ color: 'inherit' }}>
            <div style={{ display: 'flex' }}>
              <div style={{ color: !foundAssignedUser ? '#ff6600' : 'inherit' }}>
                <AssignmentIndIcon style={{ transform: 'translateY(4px)', marginRight: 6 }} />
              </div>
              <div data-test="task-assignee" style={{ paddingTop: 6, color: 'inherit' }}>
                {assigned}
              </div>
            </div>
          </TableCell>
          <TableCell component="td" className={classes.tableCell} align='left'>
            {assignedNote && Object.keys(assignedNote).length > 0 &&
              <LangConfirmationField
                dataTest="task-instructions"
                focus={false}
                canBeDeleted={false}
                multiline={true}
                text={assignedNote[Object.keys(assignedNote)[0]]}
                lang={Object.keys(assignedNote)[0]}
                isReadOnly={true} />
            }
          </TableCell>
          <TableCell component="td" className={classes.tableCell} align='left' style={{ color: 'inherit' }}>
            <div data-test="created-by" style={{ paddingTop: 6 }}>
              {createdBy}
            </div>
          </TableCell>
          <TableCell component="td" className={classes.tableCell} align='left' style={{ color: 'inherit' }}>
            <div data-test="task-date" style={{ paddingTop: 6 }}>
              {dateText || "Recent"}
            </div>
          </TableCell>
          <TableCell component="td" className={classes.tableCell} align='center'>
            <div style={{ paddingTop: 2 }}>
              {usedStatus !== REJECTED && canEditTask &&
                <Tooltip placement="right" title={usedStatus === PENDING ? 'Mark as done' : 'Done'}>
                  <span>
                    <IconButton disabled={usedStatus !== PENDING || currentUser !== assignedUser} data-test="mark-as-done" size="small" onClick={() => this.setToStatus(APPROVED)}>
                      <AssignmentTurnedInIcon color={usedStatus === APPROVED ? "secondary" : "inherit"} />
                    </IconButton>
                  </span>
                </Tooltip>
              }
            </div>
          </TableCell>
          <TableCell component="td" className={classes.tableCell} align='center'>
            <div style={{ paddingTop: 2 }}>
              {usedStatus !== APPROVED && canEditTask &&
                <Tooltip placement="right" title={usedStatus === PENDING ? 'Reject' : 'Rejected'}>
                  <span>
                    <IconButton disabled={usedStatus !== PENDING || currentUser !== assignedUser} data-test="reject-task" size="small" onClick={() => this.setToStatus(REJECTED)}>
                      <AssignmentReturnedIcon
                        style={{ ...(usedStatus === REJECTED) && { color: '#DD2C00' } }} />
                    </IconButton>
                  </span>
                </Tooltip>
              }
            </div>
          </TableCell>
          <TableCell component="td" className={classes.tableCell} align='right'>
            <div style={{ paddingTop: 2, marginRight: 12 }}>
              {currentUser === manager && usedStatus === PENDING && canEditTask &&
                <Tooltip placement="right" title='Assign'>
                  <IconButton data-test="assign-task" size="small" onClick={this.showAssignUser}>
                    <PersonIcon />
                  </IconButton>
                </Tooltip>
              }
              {usedStatus === PENDING && showAssignUserDialog && !disabled &&
                <AssignUserDialog
                  onAssignUser={this.assignUser}
                  exclude={assignedUser}
                  allowInstructions={false}
                  defaultLang={defaultLang}
                  projectUsers={projectUsers}
                  onCancel={this.cancelAssignUser}
                />
              }
            </div>
          </TableCell>
          <TableCell component="td" className={classes.tableCell} align='left'>
            {hasDiscussion &&
              <div>
                {expanded ?
                  <Tooltip title="Show less detail">
                    <IconButton size="small" onClick={this.collapseTask}>
                      <ExpandLess data-test="collapse" color="primary" />
                    </IconButton>
                  </Tooltip>
                  :
                  <Tooltip title="Show comments">
                    <IconButton size="small" onClick={this.expandTask}>
                      <ExpandMore data-test="expand" color="primary" />
                    </IconButton>
                  </Tooltip>
                }
              </div>
            }
          </TableCell>
        </TableRow>
        {expanded &&
          <TableRow
            style={{
              backgroundColor: isDeleted ?
                '#DD2C00'
                :
                usedStatus !== PENDING ?
                  '#f5f5f5'
                  :
                  '#eeeeee',
              borderBottom: 'solid 12px white',
              borderRadius: 4
            }}>
            <TableCell colSpan={8} component="td" className={classes.tableCell} align='left'>
              {hasDiscussion
                && (entitlements.includes(ENTITLEMENTS.CREATE_DISCUSSION)
                  || entitlements.includes(ENTITLEMENTS.VIEW_DISCUSSION)
                  || entitlements.includes(ENTITLEMENTS.CREATE_TASK))
                && hasDiscussion.map(discussion =>
                  <div key={discussion} style={{ backgroundColor: 'white', padding: '4px 12px 4px 12px', borderRadius: 4 }}>
                    <DiscussionViewer
                      isReadOnly={isReadOnly || usedStatus !== PENDING || disabled}
                      active={true}
                      displayNoComments={true}
                      defaultLang={defaultLang}
                      entitlements={entitlements}
                      key={discussion}
                      id={discussion}
                      graph={graph}
                      users={projectUsers} />
                  </div>
                )}
            </TableCell>
          </TableRow>
        }
      </React.Fragment>
    );
  }
}

TaskViewerTaskDisplay.defaultProps = {
  isReadOnly: false,
  disabled: false
};

TaskViewerTaskDisplay.propTypes = {
  classes: PropTypes.object,
  isReadOnly: PropTypes.bool,
  manager: PropTypes.string,
  disabled: PropTypes.bool,
  data: PropTypes.object.isRequired,
  graph: PropTypes.string.isRequired,
  onTaskCompletion: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  entitlements: PropTypes.array,
  currentUser: PropTypes.string.isRequired,
  assignedFilter: PropTypes.string,
  projectUsers: PropTypes.array.isRequired,
  defaultLang: PropTypes.string.isRequired
};

export default withStyles(styles)(withGS(TaskViewerTaskDisplay, ["ALL"], null, {}, true));